import domain from '../server-config/domain.config.js'
import { getStoreMessage } from '_h/public'
import { decryptSettlementAccount } from '@/utils/settlement-account-crypto'

export default {
  nuxtServerInit({ commit }, context) {
    commit('setApiEnv', domain.EBES_B2C_SELLER_API)
    commit('setStoreRegionId', context.app.$cookies.get('storeRegion-id'))
  },
  async initStoreInfo({ commit }) {
    try {
      const { store, openRegionStations } = await this.$axios
        .request(getStoreMessage())
        .then(r => r.data.data)

      const settlementAccount = await decryptSettlementAccount({
        encrypted: store?.settlementAccountEncrypted,
        algorithm: store?.settlementAccountAlgorithm,
        keyVersion: store?.settlementAccountKeyVersion
      })

      commit('setStoreInfo', {
        ...(store || {}),
        ...(settlementAccount ? { settlementAccount } : {}),
        // true 表示当前 settlementAccount 为脱敏值，不可作为可编辑原始数据
        settlementAccountMasked: !settlementAccount
      })
      // 开放的国家
      commit('setOpenRegionStations', openRegionStations || [])
    } catch (e) {
      console.error(e)
    }
  }
}
